import React from 'react';
import styled from '@emotion/styled';

import { useChequeContext } from '~Scenes/Handy/Context/ChequeContext';
import { useCurrency, useI18n } from '~Hooks';
import { useTableUniverse } from '~Components/TableUniverse';

const Container = styled.div`
  padding: 8px 12px 10px;
  border-top: 1px dashed var(--colorBlueGray800);
  box-shadow: 0 -12px 22px 8px rgba(14, 18, 22, 0.8);
  clip-path: inset(-56px 0px 0px 0px);
`;

const InnerContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
`;

const PriceItem = styled.div`
  font-size: 12px;
  letter-spacing: 0.24px;
  color: #d3d3d3;
  & > b {
    font-weight: 600;
    color: white;
  }
`;

const PriceSection = () => {
  const { selectedCheque } = useChequeContext();
  const { i18n } = useI18n();
  const currency = useCurrency();
  const universe = useTableUniverse();

  // selectedCheque is currenlty stale on nested update, using universe until fixed
  const cheque = universe.cheques.find((c) => c.id === selectedCheque?.id);

  if (!selectedCheque || !cheque) {
    return null;
  }

  return (
    <Container>
      <InnerContainer>
        <PriceItem>
          {i18n('Handy.Cheque.Price')} <b>{currency.format(cheque.amount)}</b>
        </PriceItem>
        <PriceItem>
          {i18n('Handy.Tables.ChequePanel.Total')}{' '}
          <b>{currency.format(cheque.amount - cheque.discount - cheque.paidAmount)}</b>
        </PriceItem>
        <PriceItem>
          {i18n('TM.Discount')} <b>{currency.format(cheque.discount)}</b>
        </PriceItem>
        {cheque.paidAmount > 0 && (
          <PriceItem>
            {i18n('Handy.Cheque.Paid')} <b>{currency.format(cheque.paidAmount)}</b>
          </PriceItem>
        )}
        {cheque.serviceCharge && (
          <PriceItem>
            {i18n('Handy.Cheque.Service')} {cheque.serviceCharge.percentage}%{' '}
            <b>{currency.format(cheque.serviceCharge.amount)}</b>
          </PriceItem>
        )}
      </InnerContainer>
    </Container>
  );
};

export default PriceSection;
